import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { SELECTION_LIST } from '../utils/testing/TestIDs';
import styled from '../utils/styling/styled-components';
import { SelectionListRow } from './SelectionListRow';
var Container = styled.div(_templateObject());
export var SelectionList = function SelectionList(_ref) {
  var options = _ref.options,
      value = _ref.value,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect,
      rowStyle = _ref.rowStyle,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": SELECTION_LIST,
    className: className
  }, options.map(function (option) {
    var Component = option.component;
    var rowProps = {
      key: option.value,
      isChecked: value === option.value,
      option: option,
      onSelect: onSelect,
      rowStyle: rowStyle
    };
    return Component ? /*#__PURE__*/React.createElement(Component, rowProps) : /*#__PURE__*/React.createElement(SelectionListRow, rowProps);
  }));
};